<div class="modal-content modal-content-right">
  <div class="modal-header">
    <h5 class="modal-title">Confirm Action</h5>
    <button type="button" class="close" (click)="close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-sm-12">
        <div class="form-group">
          <label>Send payment link to customer via {{ modeTxt }}</label>
          <input
            class="form-control"
            type="email"
            *ngIf="mode == 'email'"
            [(ngModel)]="email"
            autocomplete="new-password"
            style="text-align: center"
            placeholder="Email"
          />
          <input
            class="form-control"
            type="text"
            *ngIf="mode == 'phoneNumber'"
            [(ngModel)]="phoneNumber"
            autocomplete="new-password"
            style="text-align: center"
            placeholder="Phone Number"
          />
        </div>
      </div>
    </div>
  </div>
  <div class="text-right modal-footer">
    <button
      type="button"
      class="btn btn-outline"
      [disabled]="!canSend()"
      (click)="send()"
    >
      Send
    </button>
  </div>
</div>
